export enum Role {
  ADMIN = 'admin',
  PARTNER = 'partner',
  INSURER = 'insurer',
}
